var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/\u5206\u4EAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BE6\\u60C5",
    transform: "translate(-345.000000, -154.000000)",
    fill: "#386BD7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(15.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(329.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6816693,16 L1.31647913,16 C0.590656602,16 0,15.4297367 0,14.7307619 L0,5.74598659 C0,5.04522416 0.590656602,4.47674852 1.31647913,4.47674852 L3.25138869,4.47674852 C3.55875231,4.47674852 3.80686512,4.71629486 3.80686512,5.0130463 C3.80686512,5.30979773 3.55875231,5.54934407 3.25138869,5.54934407 L1.31647913,5.54934407 C1.20353226,5.54934407 1.11095286,5.63872703 1.11095286,5.74598659 L1.11095286,14.7307619 C1.11095286,14.8398092 1.20353226,14.9274045 1.31647913,14.9274045 L11.6835209,14.9274045 C11.7964677,14.9274045 11.8890471,14.8380215 11.8890471,14.7307619 L11.8890471,5.74598659 C11.8890471,5.63693937 11.7964677,5.54934407 11.6835209,5.54934407 L9.66158667,5.54934407 C9.35422305,5.54934407 9.10611024,5.30979773 9.10611024,5.0130463 C9.10611024,4.71629486 9.35422305,4.47674852 9.66158667,4.47674852 L11.6835209,4.47674852 C12.4093434,4.47674852 13,5.04701182 13,5.74598659 L13,14.7307619 C12.9981484,15.4297367 12.4074918,16 11.6816693,16 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48611309,10.2866411 C6.17874947,10.2866411 5.93063666,10.0470947 5.93063666,9.75034329 L5.93063666,1.10701085 C5.93063666,0.810259416 6.17874947,0.570713078 6.48611309,0.570713078 C6.79347671,0.570713078 7.04158952,0.810259416 7.04158952,1.10701085 L7.04158952,9.75034329 C7.04158952,10.0470947 6.79347671,10.2866411 6.48611309,10.2866411 L6.48611309,10.2866411 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14200256,3.36661213 C3.99943028,3.36661213 3.856858,3.31298236 3.7476143,3.20751046 C3.53097849,2.99656667 3.53283008,2.65691141 3.75131748,2.44954294 L6.14356929,0.155976134 C6.36205669,-0.0531799977 6.71200684,-0.0513923384 6.92864264,0.157763793 L9.28756587,2.4513306 C9.50420168,2.66227439 9.50235009,3.00014199 9.28571429,3.20929812 C9.06722689,3.41845425 8.71727674,3.41666659 8.50064093,3.20751046 L6.53240279,1.29471507 L4.53268765,3.20929812 C4.42529554,3.31477002 4.28272326,3.36661213 4.14200256,3.36661213 L4.14200256,3.36661213 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.bcdeb47cac9d6f6698c7b2ffab4f6e82.svg";
export { ForwardRef as ReactComponent };